import React, { useEffect, useMemo, useState } from 'react';
import { Container, Nav, Navbar, Row, Col, NavDropdown } from 'react-bootstrap';
import Logo from '../../assets/images/logo1.png';
import LogoMob from '../../assets/images/logoMob@3x.png';
import MobileMenu from '../../assets/images/menuMob.svg';
import Bell from '../../assets/images/bell_internal.png';
import UserPhoto from '../../assets/images/profile1.png';
import LogOut from '../../assets/images/logout.png';
import { useHistory, useLocation } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import './HeaderNew.css';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { GetUserData, selectUserData } from '../../features/home/userSlice';
import { dev } from '../../features/network/ApiCall';
import { GetLogout, selectLogout } from '../../features/login/LogoutSlice';
import { LogoutUser } from '../../constant/Logout';
import { isAdmin, isPermited } from '../../features/localStorage';
import { isSSO } from '../../features/localStorage';
import swal from 'sweetalert';
import HeaderDropdown from './HeaderDropdown';
function Headernew() {
  let history = useHistory();
  const location: any = useLocation();

  const [show, setShow] = useState(false);
  const getLogout = useAppSelector(selectLogout);
  const dispatch = useAppDispatch();
  const logOut = async () => {
    LogoutUser();
  };

  const userData = useAppSelector(selectUserData);
  const userDetails = localStorage.getItem('userDetails');
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);

  // const userPhotoDetails = localStorage.getItem("userPhotoDetails");
  // const userPhotoDetailsList: any = userPhotoDetails;
  // const userPhotoDetailsJson = JSON?.parse(userPhotoDetailsList);

  const isSSO = localStorage.getItem('isSSO');
  const isSSOList: any = isSSO;
  const isSSOJson = JSON.parse(isSSOList);
  // console.log(userPhotoDetailsJson?.userPhoto,"userPhotoDetailsJson?.userPhoto")
  const userPhotoUrl: any = userData?.userPhoto
    ? userData?.userPhoto
    : userDetailsJson?.user?.userPhoto
    ? userDetailsJson?.user?.userPhoto
    : '';

  useEffect(() => {
    async function fetchUser() {
      await dispatch(GetUserData(userDetailsJson));
    }
    fetchUser();
    //console.log(localStorage.getItem('isSession'))
    let isCheckSession = localStorage.getItem('isSession');
    console.log('=== isCheckSession ===>', isCheckSession);
    if (!isCheckSession) {
      // swal({
      //   text: 'Login Expired, Click here to login again.',
      //   icon: 'warning',
      //   dangerMode: true
      // }).then(async () => {
      localStorage.setItem(
        'endpoint',
        !!location?.pathname ? location?.pathname : ''
      );
      localStorage.removeItem('userDetails');
      localStorage.removeItem('otp');
      localStorage.removeItem('forgetpass');
      localStorage.removeItem('isSSO');
      localStorage.removeItem('URP');
      localStorage.removeItem('store');
      localStorage.removeItem('isSession');
      LogoutUser();
      window.location.href = '/login';
      // });
    }
  }, []);

  const isEvent: boolean = useMemo(() => {
    const id = userDetailsJson?.UserId + '';
    // console.log('=== USER ID ====>', id);
    const arr: any = [
      // '23069148',
      // '50000268',
      // '25004328',
      // '25025310',
      // '23137327',
      // '205133',
      // '211002',
      // '25020058',
      // '23141621',
      // '25003295'
    ];
    const is = !!id ? arr.includes(id) : false;
    // console.log('=== IS EVENT ====>', arr.includes(id));
    return is;
  }, [userDetailsJson]);

  const mobileMenuClick = () => {
    if (window.innerWidth < 1000) {
      setShow(true);
    }
  };
  return (
    <div className='start-new-mmenu'>
      <nav id='nav-start'>
        <div className='top-logo desk'>
          <a href='/home'>
            <img src={Logo} className='logo' />
          </a>
        </div>
        <div className='mobiletop-logo mob mob-m13'>
          <a href='/home'>
            <img src={LogoMob} className='logo mob' />
          </a>
        </div>

        <label htmlFor='drop' onClick={() => setShow(false)} className='toggle'>
          <img src={MobileMenu} style={{ width: '24px', marginTop: '13px' }} />
        </label>

        <input type='checkbox' id='drop' onChange={() => setShow(false)} />
        {/* {userDetailsJson.InitialLogin===false? */}
        <ul className={show ? 'menu hide' : 'menu'}>
          <div className='profilebg mob'>
            <li>
              {userPhotoUrl ? (
                <img src={userPhotoUrl} className='profile mob-profile' />
              ) : (
                <img src={UserPhoto} className='profile mob-profile' />
              )}
              <div className='profiledata mob-profile'>
                <h3>{userData?.name}</h3>
                {/* <p>GCO</p> */}
              </div>
            </li>
          </div>

          <li>
            <NavLink
              to='/home'
              onClick={mobileMenuClick}
              activeClassName='menuactive'
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to='/policies'
              onClick={mobileMenuClick}
              activeClassName='menuactive'
            >
              Ethics Policies
            </NavLink>
          </li>
          {/* <li>
            <NavLink
              to='/learning'
              onClick={mobileMenuClick}
              activeClassName='menuactive'
            >
              Ethics Awareness
            </NavLink>
          </li>
          <li>
            <NavLink
              to='/help'
              onClick={mobileMenuClick}
              activeClassName='menuactive'
            >
              Ethics counsellors
            </NavLink>
          </li> */}
          <li>
            {/* <NavLink
              to="/event"
              onClick={mobileMenuClick}
              activeClassName="menuactive"
              
            >
              Events
            </NavLink> */}
            {!!isEvent ? <HeaderDropdown /> : ''}
          </li>

          <div className='mob'>
            <li className='logout'>
              <a
                onClick={() => {
                  LogoutUser();
                  // handleLogout()
                  // localStorage.removeItem("userDetails");
                  // localStorage.removeItem("otp");
                  // localStorage.removeItem("forgetpass");
                  // localStorage.removeItem("isSSO");
                  // localStorage.removeItem("URP");
                  // localStorage.removeItem("store");
                  // localStorage.removeItem("isSession");
                  // window.location.href = `${dev}/api/users/user/logout?accessToken=${userDetailsJson.accessToken}`;
                }}
                // href={
                //   `${dev}` +
                //   "/users/user/logout?accessToken=" +
                //   `${userDetailsJson.accessToken}`
                // }
              >
                <img src={LogOut} /> Logout
              </a>
              {/* <a href="#">
                <img src={LogOut} /> Logout{" "}
              </a> */}
              <div className='version'>
                {' '}
                <p>Version 1.1.1</p>
              </div>
            </li>
          </div>
        </ul>
        {/* :null} */}

        <div className='right-menu'>
          <div className='top-right-menu'>
            <ul>
              {/* <li>
                <a href="#">
                  <img src={Bell} />
                </a>
              </li> */}

              <li className='dropdown desk'>
                {userPhotoUrl ? (
                  <img
                    src={userPhotoUrl}
                    className='desk'
                    height='40'
                    style={{ marginTop: '3px' }}
                  />
                ) : (
                  <img
                    src={UserPhoto}
                    className='desk'
                    height='40'
                    style={{ marginTop: '3px' }}
                  />
                )}
                <div className='dropdown-content'>
                  {isSSOJson !== true ? (
                    <a className='dropdown-item' href='/profile'>
                      Profile
                    </a>
                  ) : (
                    <a
                      className='dropdown-item'
                      target='_blank'
                      rel='noopener noreferrer'
                      href='https://performancemanager4.successfactors.com/sf/liveprofile?company=Mahindra&loginMethod=SSO'
                    >
                      Profile
                    </a>
                  )}

                  {/* {isPermited(12,1) && (
                    <a className="dropdown-item" href="/ManageCompany">
                      {" "}
                      Manage Company{" "}
                    </a>
                  )} */}

                  {/* {isPermited(10,1) && (
                    <a className="dropdown-item" href="/UserGroup">
                      {" "}
                      Assign Role{" "}
                    </a>
                  )} */}

                  <a
                    className='dropdown-item'
                    onClick={() => {
                      LogoutUser();
                      //handleLogout()
                      // localStorage.removeItem("userDetails");
                      // localStorage.removeItem("otp");
                      // localStorage.removeItem("forgetpass");
                      // localStorage.removeItem("isSSO");
                      // localStorage.removeItem("URP");
                      // localStorage.removeItem("store");
                      // localStorage.removeItem("isSession");
                      // window.location.href = `${dev}/api/users/user/logout?accessToken=${userDetailsJson.accessToken}`;
                    }}
                    // href={
                    //   `${dev}` +
                    //   "/users/user/logout?accessToken=" +
                    //   `${userDetailsJson.accessToken}`
                    // }
                    // href="/login"
                  >
                    Logout
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Headernew;
